import React from 'react';
import { useFormContext } from 'react-hook-form';
import { IDocumentValues, useDocumentCarouselStyles } from './documentCarouselUtil';
import Fieldset from '../connectedForm/Fieldset';
import CheckboxInput from '../connectedForm/CheckboxInput';

const DocumentCarouselResetToStart = () => {
  const { watch, setValue } = useFormContext<IDocumentValues>();

  const styles = useDocumentCarouselStyles();

  return (
    <div className={styles.row}>
      <Fieldset cols={1} style={{ paddingLeft: 0, paddingRight: 0 }}>
        <CheckboxInput
          data-testid={'document-carousel-reset-to-all-items'}
          label="Reset to all items"
          labelCols={3 / 12}
          inputCols={9 / 12}
          value={watch('resetToStart')}
          onChange={(event: any) => {
            setValue('resetToStart', event?.target?.checked, {
              shouldTouch: true,
              shouldDirty: true,
            });
          }}
          hint={'Reset any back orders to include all order lines on the delivery note'}
        />
      </Fieldset>
    </div>
  );
};

export default DocumentCarouselResetToStart;
